// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"9b571453","329":"9b571453","466":"9b571453","642":"9b571453","830":"b07525d0"}[chunkId] + ".chunk.css";
};